import { render, staticRenderFns } from "./StoryDetail.vue?vue&type=template&id=feb48c62&scoped=true&"
import script from "./StoryDetail.vue?vue&type=script&lang=js&"
export * from "./StoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./StoryDetail.vue?vue&type=style&index=0&id=feb48c62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb48c62",
  null
  
)

export default component.exports